// @spec DHB-STR-038
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { DataAuditPage } from '@/features/datahub/components/DataAuditPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/datahub/audit')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.dataAuditTrail'),
  }),
  component: DataAuditPage,
});
